export enum EmailJobGrouping {
  STUDY = 'STUDY',
  SITE = 'SITE',
}
